import { RefObject, useCallback, useState } from "react"

type CmdkFocusParams = {
  contentRef: RefObject<HTMLDivElement | null>
  inputRef: RefObject<HTMLInputElement | null>
}

export function useCmdkFocus(params: CmdkFocusParams) {
  const { contentRef, inputRef } = params
  const [focusIndex, _setFocusIndex] = useState(0)

  const setFocusIndex = useCallback((index: number, scroll = false) => {
    _setFocusIndex(index)

    if (document.activeElement !== inputRef.current) {
      inputRef.current?.focus({ preventScroll: true })
    }

    if (scroll) {
      setTimeout(() => {
        contentRef.current
          ?.querySelector(`[data-option-index="${index}"]`)
          ?.scrollIntoView({ block: "nearest", behavior: "instant" })
      }, 0)
    }
  }, [])

  return {
    focusIndex,
    setFocusIndex,
  }
}
